module.exports = __webpack_public_path__ + "static/media/GM4.36b14115.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/GM4.jpg
// module id = 1149
// module chunks = 0